/**
 * Mosterd — Recently Viewed Products
 *
 * Saves product handles to localStorage on product page visits.
 * On section load, fetches rendered product cards via Shopify Section Rendering API
 * and inserts them into the #md-recently-viewed-grid container.
 */

(function () {
  'use strict';

  const STORAGE_KEY = 'md-recently-viewed';
  const MAX_STORED = 10;
  const MAX_DISPLAYED = 6;
  const SECTION_ID = 'mosterd-recently-viewed-card';

  /**
   * Get stored product handles from localStorage.
   * @returns {string[]}
   */
  function getStoredHandles() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      return [];
    }
  }

  /**
   * Save product handles to localStorage.
   * @param {string[]} handles
   */
  function saveHandles(handles) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(handles));
    } catch (e) {
      // localStorage unavailable
    }
  }

  /**
   * Record the current product handle if on a product page.
   * Skips duplicates and enforces max limit.
   */
  function recordCurrentProduct() {
    // Detect product page by meta tag or URL pattern
    const handleMeta = document.querySelector('meta[property="og:url"]');
    const url = handleMeta ? handleMeta.content : window.location.pathname;
    const match = url.match(/\/products\/([^?#/]+)/);
    if (!match) return;

    const currentHandle = match[1];
    let handles = getStoredHandles();

    // Remove if already present (will re-add at front)
    handles = handles.filter(function (h) { return h !== currentHandle; });

    // Add to front
    handles.unshift(currentHandle);

    // Enforce max limit
    if (handles.length > MAX_STORED) {
      handles = handles.slice(0, MAX_STORED);
    }

    saveHandles(handles);
  }

  /**
   * Fetch rendered product cards via Section Rendering API.
   * @param {string[]} handles
   * @returns {Promise<string[]>}
   */
  async function fetchRecentlyViewed(handles) {
    const cards = [];
    for (const handle of handles.slice(0, MAX_DISPLAYED)) {
      try {
        const resp = await fetch(
          '/products/' + handle + '?section_id=' + SECTION_ID
        );
        if (resp.ok) {
          const html = await resp.text();
          cards.push(html);
        }
      } catch (e) {
        console.warn('Failed to fetch recently viewed:', handle, e);
      }
    }
    return cards;
  }

  /**
   * Render the recently viewed section.
   */
  async function renderRecentlyViewed() {
    var grid = document.getElementById('md-recently-viewed-grid');
    var section = document.getElementById('md-recently-viewed-section');
    if (!grid || !section) return;

    var handles = getStoredHandles();

    // Exclude the current product handle
    var currentMatch = window.location.pathname.match(/\/products\/([^?#/]+)/);
    if (currentMatch) {
      var currentHandle = currentMatch[1];
      handles = handles.filter(function (h) { return h !== currentHandle; });
    }

    if (handles.length === 0) {
      section.style.display = 'none';
      return;
    }

    var cards = await fetchRecentlyViewed(handles);
    if (cards.length === 0) {
      section.style.display = 'none';
      return;
    }

    grid.innerHTML = cards.join('');
  }

  // Record current product on page load
  recordCurrentProduct();

  // Render recently viewed products when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', renderRecentlyViewed);
  } else {
    renderRecentlyViewed();
  }
})();
